<template>
    <Teleport to="body">
        <div class="modal fade" ref="modal" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered max-w:464!">
                <div class="modal-header"></div>
                <div class="modal-content">
                    <div class="modal-body p-0">
                        <div class="t:center p:32|24 p:64|48@sm">
                            <div class="f:32">
                                為確保帳號安全<br>
                                請重新登入 OPT歐趴糖
                            </div>
                            <div class="mt:40">
                                <div class="form-group t:left">
                                    <label>密碼</label>
                                    <input class="form-control mt:8" :id="id" placeholder="輸入6位數以上的密碼" ref="input" type="password" v-model.trim="form.password" />
                                </div>
                            </div>
                            <div class="mt:40">
                                <button class="btn btn-primary" @click="submit" :disabled="!form.password" type="button">登入</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Teleport>
</template>

<script setup>
    const form = ref({});
    const id = nextId();
    const input = ref();

    let instance;

    const modal = ref();

    const emit = defineEmits(["submit"]);

    const hide = () => {
        instance.hide();
    };

    const show = () => {
        form.value.password = "";

        instance.show();
    };

    const submit = () => {
        emit("submit", {
            password: form.value.password
        });
    };

    defineExpose({ hide, show });

    onMounted(() => {
        instance = new bootstrap.Modal(modal.value);

        modal.value.addEventListener("shown.bs.modal", () => input.value.focus());
    });
</script>
